module.exports = __webpack_public_path__ + "static/education-8609259eb1d1aa4d1b2775c312eae062.jpeg";